(function () {
  'use strict';

  /* Carrousel de la page d'accueil */
  document.querySelectorAll('[data-carousel]').forEach(function (c) {
    var slides = c.querySelector('[data-slides]');
    var dots = c.querySelector('[data-dots]');
    var prev = c.querySelector('[data-prev]');
    var next = c.querySelector('[data-next]');
    if (!slides) return;
    var n = slides.children.length;
    if (n < 2) {
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
      return;
    }
    function go(i) { slides.scrollTo({ left: slides.clientWidth * i }); }
    function current() { return Math.round(slides.scrollLeft / slides.clientWidth); }
    function sync() {
      var idx = current();
      if (!dots) return;
      Array.prototype.forEach.call(dots.children, function (d, j) {
        d.setAttribute('aria-current', j === idx ? 'true' : 'false');
      });
    }
    if (dots) {
      for (var i = 0; i < n; i++) {
        (function (i) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'dot';
          d.setAttribute('aria-label', 'Offre ' + (i + 1) + ' sur ' + n);
          d.addEventListener('click', function () { go(i); });
          dots.appendChild(d);
        })(i);
      }
    }
    slides.addEventListener('scroll', sync);
    if (prev) prev.addEventListener('click', function () { go((current() - 1 + n) % n); });
    if (next) next.addEventListener('click', function () { go((current() + 1) % n); });
    sync();
  });

  /* Rail de produits */
  document.querySelectorAll('.rail-wrap').forEach(function (w) {
    var rail = w.querySelector('[data-rail]');
    var l = w.querySelector('[data-rail-prev]');
    var r = w.querySelector('[data-rail-next]');
    if (!rail) return;
    if (l) l.addEventListener('click', function () { rail.scrollBy({ left: -rail.clientWidth * 0.8 }); });
    if (r) r.addEventListener('click', function () { rail.scrollBy({ left: rail.clientWidth * 0.8 }); });
  });

  /* Copier le code promo */
  document.querySelectorAll('[data-copy]').forEach(function (btn) {
    var label = btn.textContent;
    var code = btn.getAttribute('data-copy');
    function reset() { setTimeout(function () { btn.textContent = label; }, 1800); }
    btn.addEventListener('click', function () {
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(function () { btn.textContent = 'Code copié'; reset(); },
            function () { btn.textContent = 'Code : ' + code; });
        } else { btn.textContent = 'Code : ' + code; }
      } catch (e) { btn.textContent = 'Code : ' + code; }
    });
  });

  /* Tri et filtres : envoi automatique */
  document.querySelectorAll('[data-autosubmit]').forEach(function (el) {
    el.addEventListener('change', function () {
      var f = el.form || el.closest('form');
      if (f) f.submit();
    });
  });

  /* Galerie de la fiche produit */
  var thumbs = document.querySelectorAll('.thumb');
  var mainWrap = document.querySelector('[data-main-img]');
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      var img = mainWrap && mainWrap.querySelector('img');
      if (!img) return;
      img.removeAttribute('srcset');
      img.src = t.getAttribute('data-src');
      img.alt = t.getAttribute('data-alt') || '';
      thumbs.forEach(function (o) { o.setAttribute('aria-current', o === t ? 'true' : 'false'); });
    });
  });

  /* Variantes : mise à jour du prix et du bouton */
  var select = document.querySelector('[data-variant-select]');
  if (select) {
    var priceEl = document.querySelector('[data-price]');
    var compareEl = document.querySelector('[data-compare]');
    var codeEl = document.querySelector('[data-code]');
    var addBtn = document.querySelector('[data-add]');
    select.addEventListener('change', function () {
      var o = select.options[select.selectedIndex];
      if (priceEl) priceEl.textContent = o.getAttribute('data-price');
      if (compareEl) {
        var cmp = o.getAttribute('data-compare');
        compareEl.textContent = cmp || '';
        compareEl.hidden = !cmp;
      }
      if (codeEl) codeEl.textContent = o.getAttribute('data-code') || '';
      if (addBtn) {
        var ok = o.getAttribute('data-available') === 'true';
        addBtn.disabled = !ok;
        addBtn.textContent = ok ? 'Ajouter au panier' : 'Épuisé';
      }
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', select.value);
        window.history.replaceState({}, '', u.toString());
      } catch (e) {}
    });
  }

  /* Filtres : ouverts par défaut sur ordinateur */
  if (window.matchMedia && window.matchMedia('(min-width:960px)').matches) {
    document.querySelectorAll('details.filters').forEach(function (d) { d.open = true; });
  }

  /* Menu mobile : un appui sur un rayon ouvre ses sous-catégories */
  var mobileMq = window.matchMedia ? window.matchMedia('(max-width: 959px)') : { matches: false };
  var subLinks = document.querySelectorAll('nav.main [data-panel]');
  function closeSubPanels() {
    document.querySelectorAll('.m-panel').forEach(function (p) { p.hidden = true; });
    subLinks.forEach(function (a) {
      a.setAttribute('aria-expanded', 'false');
      if (a.parentNode) a.parentNode.classList.remove('open');
    });
  }
  subLinks.forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (!mobileMq.matches) return;
      e.preventDefault();
      var panel = document.getElementById(a.getAttribute('data-panel'));
      if (!panel) return;
      var willOpen = panel.hidden;
      closeSubPanels();
      if (willOpen) {
        panel.hidden = false;
        a.setAttribute('aria-expanded', 'true');
        a.parentNode.classList.add('open');
        var top = a.parentNode.parentNode;
        if (top && a.offsetLeft < top.scrollLeft) top.scrollTo({ left: a.offsetLeft - 16 });
      }
    });
  });
  document.addEventListener('click', function (e) {
    if (!mobileMq.matches) return;
    if (!e.target.closest('nav.main')) closeSubPanels();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSubPanels(); });
  window.addEventListener('resize', function () { if (!mobileMq.matches) closeSubPanels(); });
})();
